import { Component } from '@angular/core';

@Component({
  selector: 'app-activate-account-api-unavailable-view',
  templateUrl: './activate-account-api-unavailable-view.component.html',
  styleUrls: ['./activate-account-api-unavailable-view.component.scss'],
  standalone: false,
})
export class ActivateAccountApiUnavailableViewComponent {}
